import { mergeOverrides, Modal, ModalProps } from "@mezo-org/mezo-clay"

import { DEFAULT_MODAL_Z_INDEX } from "#/shared/constants"

type ModalVariant = "small" | "normal" | "tall"

export type BaseModalProps = ModalProps & {
  variant?: ModalVariant
}

const MODAL_HEIGHT_VARIANTS: Record<ModalVariant, `${string}px`> = {
  small: "516px",
  normal: "708px",
  tall: "800px",
}

export default function BaseModal({
  children,
  isOpen,
  onClose,
  variant = "normal",
  overrides,
  ...props
}: BaseModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      closeable
      onClose={onClose}
      // If more modals are the same size, let's create a special wrapper for
      // the modal in the shared component.
      overrides={mergeOverrides(
        {
          Root: {
            style: () => ({
              // Adding -1 value to make sure this is rendered below
              // wallet connect modal surface
              zIndex: DEFAULT_MODAL_Z_INDEX - 1,
            }),
          },
          Dialog: {
            style: () => ({
              width: "480px",
              height: MODAL_HEIGHT_VARIANTS[variant],
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              overflow: "hidden",
            }),
          },
          Close: {
            // TODO: Update the Clay lib to respect the overridden styles.
            style: () => ({ borderRadius: "0px" }),
          },
        },
        overrides,
      )}
      {...props}
    >
      {children}
    </Modal>
  )
}
